// extracted by mini-css-extract-plugin
var _1 = "DeleteTeam-module__animatedBackground--Hy5Lq";
var _2 = "DeleteTeam-module__buttons--cSC22";
var _3 = "DeleteTeam-module__description--uA3xv";
var _4 = "DeleteTeam-module__wrapper--TxhgC";
export { _1 as "animatedBackground", _2 as "buttons", _3 as "description", _4 as "wrapper" }
